module.exports = __webpack_public_path__ + "img/garage-open.767300c2.svg";